const getStoredPlayer = () => {
	if (typeof window === 'undefined') return null

	try {
		const player = window.localStorage.getItem('tabooPlayer')
		return player ? JSON.parse(player) : null
	} catch (error) {
		return null
	}
}

const storedPlayer = getStoredPlayer()

const initState = {
	auth: {
		isLoaded: true,
		uid: storedPlayer?.playerId || null,
		displayName: storedPlayer?.name || null,
	},
}

export const localFirebaseReducer = (state = initState, action) => {
	switch (action.type) {
		case 'LOCAL_AUTH_SET':
			return {
				...state,
				auth: {
					isLoaded: true,
					uid: action.payload.playerId,
					displayName: action.payload.name,
				},
			}
		default:
			return state
	}
}
